import { View } from 'react-native';
import TextLato from '../text/text-lato/TextLato';
import { Alerts, Neutrals } from 'src/theme-v2/colors';
import { style } from './ProgressBar.styles';
import { ProgressBarBackground } from './progress-bar-background/ProgressBarBackground';
import { ProgressBarProps } from './ProgressBar.types';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/contexts/StoreContext';

export const ProgressBar = observer((props: ProgressBarProps) => {
  const { i18n } = useStore();
  const {
    progress,
    progressColors,
    completedLabel = i18n.t('modal-picker-my-photos:completed'),
    completedColor = Alerts.Green500,
    backgroundColor = Neutrals.coldGreys.GreyCold050,
    textColor = Neutrals.main.White,
    stuckedProgressBarTimeout,
  } = props;

  const isCompleted = progress === 100;

  return (
    <View style={[style.background, { backgroundColor }]}>
      <ProgressBarBackground
        progress={progress}
        isCompleted={isCompleted}
        completedLabel={completedLabel}
        completedColor={completedColor}
        progressColors={progressColors}
        textColor={textColor}
        stuckedProgressBarTimeout={stuckedProgressBarTimeout}
      >
        {isCompleted || progress > 20 ? (
          <TextLato style={[style.text, { color: textColor }]}>
            {isCompleted ? completedLabel : progress?.toString()?.concat('%')}
          </TextLato>
        ) : (
          <></>
        )}
      </ProgressBarBackground>
    </View>
  );
});
